// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_c0B","productName":"Table_productName__3jHWD"};